/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

export const CHECK_PAYEE_CD = 'CHECK_PAYEE_CD';
export const STATE_CD = 'STATE_CD';
export const ADJUSTMENT_QTR_CD = 'ADJUSTMENT_QTR_CD';
export const DAY_COUNT_METHOD_CD = 'DAY_COUNT_METHOD_CD';
export const DRUG_TYPE_SOURCE_CD = 'DRUG_TYPE_SOURCE_CD';
export const ADJUSTMENT_DISPUTE_CD = 'ADJUSTMENT_DISPUTE_CD';
export const UNIT_TYPE_CD = 'UNIT_TYPE_CD';
export const COVER_LETTER_PLACEMENT_CD = 'COVER_LETTER_PLACEMENT_CD';
export const NON_CMS_DRUG_INCL_CD = 'NON_CMS_DRUG_INCL_CD';
export const URA_SOURCE_CD = 'URA_SOURCE_CD';
export const URA_CALC_METHOD_CD = 'URA_CALC_METHOD_CD';
export const INT_CALC_METHOD_CD = 'INT_CALC_METHOD_CD';
export const DETAIL_LEVEL_ON_INVOICE_CD = 'DETAIL_LEVEL_ON_INVOICE_CD';
export const DISPUTE_SPECIALISTS = 'DISPUTE_SPECIALISTS';
export const GET_LETTER_SENDERS = 'GET_LETTER_SENDERS';
export const ENROLLMENT_TIMING_CD = 'ENROLLMENT_TIMING_CD';
export const CLAIM_REBATE_PGM_CD = 'CLAIM_REBATE_PGM_CD';
export const DEFAULT_SYS_AUDIT = 'DEFAULT_SYS_AUDIT';
export const REBATE_UNIT_TYPE_CD = 'REBATE_UNIT_TYPE_CD';
